(function () {
  'use strict';

  // ---- Event delegation (survives morph) ----

  document.addEventListener('click', function (e) {
    var addBtn = e.target.closest('.cart-upsell__add-btn');
    if (addBtn) { handleAdd(addBtn); return; }

    var navBtn = e.target.closest('.cart-upsell__nav');
    if (navBtn) { handleNav(navBtn); return; }
  });

  // ---- Add to cart ----

  function handleAdd(btn) {
    var vid = parseInt(btn.dataset.variantId, 10);
    btn.disabled = true;
    btn.textContent = 'Adding\u2026';

    var sectionIds = [];
    document.querySelectorAll('cart-items-component').forEach(function (c) {
      if (c.dataset.sectionId) sectionIds.push(c.dataset.sectionId);
    });

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        items: [{ id: vid, quantity: 1 }],
        sections: sectionIds.join(','),
        sections_url: window.location.pathname,
      }),
    })
      .then(function (r) { if (!r.ok) throw 0; return r.json(); })
      .then(function (data) {
        document.dispatchEvent(new CustomEvent('cart:update', {
          bubbles: true,
          detail: { data: { source: 'cart-upsell', itemCount: 1, sections: data.sections } },
        }));
      })
      .catch(function () { btn.disabled = false; btn.textContent = '+ Add'; });
  }

  // ---- Slider navigation ----

  function handleNav(btn) {
    var slider = btn.closest('.cart-upsell__slider');
    if (!slider) return;
    var track = slider.querySelector('.cart-upsell__track');
    var card = track && track.querySelector('.cart-upsell__card');
    if (!track || !card) return;

    var amount = card.offsetWidth + 10;
    track.scrollBy({
      left: btn.classList.contains('cart-upsell__nav--prev') ? -amount : amount,
      behavior: 'smooth',
    });
  }

  // ---- Slider scroll-based arrow visibility ----
  // Buttons only exist in DOM when card_count >= 4 (Liquid handles that).
  // JS just toggles prev/next based on scroll position.

  var currentTrack = null;
  var resizeObs = null;

  function initSlider() {
    var container = document.getElementById('cart-upsell-module');
    if (!container) return;

    var track = container.querySelector('.cart-upsell__track');
    if (!track) return;

    var prev = container.querySelector('.cart-upsell__nav--prev');
    var next = container.querySelector('.cart-upsell__nav--next');

    // No nav buttons in DOM = nothing to manage
    if (!prev && !next) return;

    if (track === currentTrack) { updateScroll(track, prev, next); return; }
    currentTrack = track;

    track.addEventListener('scroll', function () { updateScroll(track, prev, next); }, { passive: true });

    if (window.ResizeObserver) {
      if (resizeObs) resizeObs.disconnect();
      resizeObs = new ResizeObserver(function () { updateScroll(track, prev, next); });
      resizeObs.observe(track);
    }

    updateScroll(track, prev, next);
  }

  function updateScroll(track, prev, next) {
    var atStart = track.scrollLeft <= 2;
    var atEnd = track.scrollLeft + track.clientWidth >= track.scrollWidth - 2;
    if (prev) prev.style.display = atStart ? 'none' : 'flex';
    if (next) next.style.display = atEnd ? 'none' : 'flex';
  }

  // ---- Re-init after cart updates (morph replaces DOM) ----

  document.addEventListener('cart:update', function () {
    setTimeout(function () {
      currentTrack = null;
      initSlider();
    }, 500);
  });

  // ---- Init ----

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initSlider);
  } else {
    initSlider();
  }
})();
